import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6t4mvvvp2x: FaireBrandEntity = {
  token: "b_6t4mvvvp2x",
  type: "brand",
  name: "The Sis Kiss",
  avatarUrl:
    "https://cdn.faire.com/fastly/031f148d12d37f8f8954b15f7dcb18e9fed5a35063cb36b625257eec405aaca1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/73e35b75ec9d21363cbfd1895836e12aae431793461119259c24e567dfbcf063.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/031f148d12d37f8f8954b15f7dcb18e9fed5a35063cb36b625257eec405aaca1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/73e35b75ec9d21363cbfd1895836e12aae431793461119259c24e567dfbcf063.jpeg",
  location: "Cleveland, OH, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 77,
  isInsider: true,
  description:
    "WE ARE The Sis Kiss ™\n\nMegan started her career as a trial attorney, which seemed perfectly matched with her talkative, enthusiastic, and dramatic nature. She thrived...until she didn’t. She found herself feeling depressed and anxious, and one day had a panic attack in court. She knew she had to make a change.\n\nThankfully, before Megan’s exit from law, Megan and her sister had started The Sis Kiss. It was the side hustle the sisters loved that blossomed from their personal need for more dainty bangles to fit their petite wrists. Friends became fans, and then customers!\n\nMegan realized the side hustle wasn’t JUST a side hustle to her. Her passion, drama, and desire had returned with every order and opportunity for growth with The Sis Kiss. After growing into the CEO role at The Sis Kiss she has never looked back. Designing, building a team, and of course, all things shiny are her calling, passion, and purpose.\n\nThe Sis Kiss family of brands now includes TSK Atelier and Wildly Unprofessional, our new podcast. More details about our brand can be found on our website. Please review our website for additional details concerning our policies and working with us. We are happy to have you here and look forward to building a partnership with our customers and retailers. ",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:17.613Z",
    importedBy: "entity-db-cli",
  },
};
